<template>
    <div class="icono">
        <v-layout row wrap class="contenedor">
            <v-flex>
                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                        <div class="glosario-imagen hvr hvr-scale"  v-on="on" @click="activarGlosario()">
                            <!--
                                <img @click="activarGlosario()"
                                    :src="require('../assets/presentacion/elementos de portada-08.png')"
                                    alt="Icono para activar glosario"
                                >
                            -->
                            <personaje  class="btn-glosario"/>
                        </div>
                    </template>
                    <div class="glosario-tooltip">
                        <span>Puedes consultar los conceptos del curso en el glosario disponible aquí.</span>
                    </div>
                </v-tooltip>
            </v-flex>
        </v-layout>
        <!-- MODAL DE GLOSARIO -->
        <modal-glosario-app v-model="glosario" :fullscreen="true">
            <template slot="modaltittle"></template>
            <template slot="modalcontent"><Glosario/></template>
        </modal-glosario-app>
    </div>
</template>
<script>
import Glosario from '../components/Glosario'
import personaje from '../components/personaje-icon'
export default {
    components: {
        Glosario,
        personaje,
    },
    data(){
        return{
            glosario:false,
            modulo:0
        }
    },
    methods:{
        activarGlosario(){
            this.glosario=true
        },
    },
    mounted () {
        console.log('La altura es: '+this.$vuetify.breakpoint.height)
    },
}
</script>
<style lang="scss" scoped>
@import '../sass/globals';
.icono{
    z-index: 3;
    position: fixed;
    top: 5px;//80px;
    right: 20px;
}
.glosario-imagen{
    width: 8rem;
    height: auto;
}
.glosario-tooltip{
    width: 200px;
}
.btn-glosario{
    cursor: pointer;
}
@media (max-width: 960px) {
    .icono{
        position: fixed;
        top: 5px;
        right: 20px;
    }
}
@media (max-width: 600px) {
    .icono{
        position: fixed;
        top: 5px;
        right: 10px;
    }
    .glosario-imagen{
        width: 4rem;
        height: auto;
    }
}
</style>